// Generated by ReScript, PLEASE EDIT WITH CARE

import * as S from "sury/src/S.res.mjs";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Caml_js_exceptions from "rescript/lib/es6/caml_js_exceptions.js";

var responseIdentifier = S.recursive(function (responseIdentifierSchema) {
      return S.union([
                  S.object(function (s) {
                        s.tag("responseIdentifier", "Group");
                        return {
                                TAG: "Group",
                                _0: s.f("groupName", S.string),
                                _1: s.f("link", responseIdentifierSchema)
                              };
                      }),
                  S.object(function (s) {
                        s.tag("responseIdentifier", "AnswerSet");
                        return {
                                TAG: "AnswerSet",
                                _0: s.f("setName", S.string),
                                _1: s.f("response", responseIdentifierSchema)
                              };
                      }),
                  S.object(function (s) {
                        s.tag("responseIdentifier", "IdPair");
                        return {
                                TAG: "IdPair",
                                _0: s.f("responseId", S.string),
                                _1: s.f("responseId2", S.string)
                              };
                      }),
                  S.object(function (s) {
                        s.tag("responseIdentifier", "SingleId");
                        return {
                                TAG: "SingleId",
                                _0: s.f("responseId", S.string)
                              };
                      })
                ]);
    });

var responsePayload = S.union([
      S.object(function (s) {
            s.tag("responsePayload", "BoolResponsePayload");
            return {
                    TAG: "BoolResponsePayload",
                    _0: s.f("responseIdentifier", responseIdentifier)
                  };
          }),
      S.object(function (s) {
            s.tag("responsePayload", "StrResponsePayload");
            return {
                    TAG: "StrResponsePayload",
                    _0: s.f("responseIdentifier", responseIdentifier),
                    _1: s.f("responseText", S.string)
                  };
          })
    ]);

var responseType = S.union([
      S.object(function (s) {
            s.tag("responseType", "SetResponse");
            return {
                    TAG: "SetResponse",
                    _0: s.f("responsePayload", responsePayload)
                  };
          }),
      S.object(function (s) {
            s.tag("responseType", "ToggleResponse");
            return {
                    TAG: "ToggleResponse",
                    _0: s.f("responsePayload", responsePayload)
                  };
          })
    ]);

var responseArray = S.array(responseType);

var questionIndex = S.object(function (s) {
      return s.f("questionIndex", S.$$int);
    });

var questionMarkingSchema = S.union([
      S.literal("QuestionMarking"),
      S.literal("ResponseMarking"),
      S.literal("ResponseMarkingWithDistractors"),
      S.literal("AnswerSetMarkingPointPerSetWithDistractors"),
      S.literal("AnswerSetMarkingWithDistractors")
    ]);

var questionStateType = S.union([
      S.object(function (s) {
            s.tag("questionStateType", "QuestionAttempted");
            return {
                    TAG: "QuestionAttempted",
                    _0: s.f("responseArray", responseArray),
                    _1: s.fieldOr("questionMarking", questionMarkingSchema, "QuestionMarking")
                  };
          }),
      S.object(function (s) {
            s.tag("questionStateType", "NotAttempted");
            return "NotAttempted";
          })
    ]);

var answerShape = S.object(function (s) {
      return {
              questionCorrect: s.f("questionCorrect", S.bool),
              answer: s.f("answer", S.list(S.string)),
              incorrectResponses: s.f("incorrectResponses", S.list(S.string)),
              responsesCorrect: s.f("responsesCorrect", S.option(S.$$int)),
              responsesComplete: s.f("responsesComplete", S.option(S.$$int))
            };
    });

var markStateType = S.union([
      S.object(function (s) {
            s.tag("markStateType", "BoolMarkState");
            return {
                    TAG: "BoolMarkState",
                    _0: s.f("answerShape", answerShape)
                  };
          }),
      S.object(function (s) {
            s.tag("markStateType", "NotMarked");
            return "NotMarked";
          })
    ]);

var state = S.object(function (s) {
      return {
              questionStates: /* [] */0,
              markStates: /* [] */0,
              mode: s.f("mode", S.$$enum([
                        "Activity",
                        "Assessment"
                      ])),
              questionsComplete: s.f("questionsComplete", S.$$int),
              questionsCorrect: s.fieldOr("questionsCorrect", S.$$int, 0),
              questionsIncorrect: s.fieldOr("questionsIncorrect", S.$$int, 0),
              hasResponseMarking: s.fieldOr("hasResponseMarking", S.bool, false)
            };
    });

var questionStates = S.object(function (s) {
      return s.f("questionStates", S.list(questionStateType));
    });

var markStates = S.object(function (s) {
      return s.f("markStates", S.list(markStateType));
    });

var questionStatesQuestionIndexes = S.object(function (s) {
      return s.f("questionStates", S.list(questionIndex));
    });

var markStatesQuestionIndexes = S.object(function (s) {
      return s.f("markStates", S.list(questionIndex));
    });

function decodeQuestionStates(json) {
  var match = S.parseJsonStringOrThrow(json, questionStates);
  var match$1 = S.parseJsonStringOrThrow(json, questionStatesQuestionIndexes);
  return Belt_List.zip(match, match$1);
}

function decodeMarkStates(json) {
  var match = S.parseJsonStringOrThrow(json, markStates);
  var match$1 = S.parseJsonStringOrThrow(json, markStatesQuestionIndexes);
  return Belt_List.zip(match, match$1);
}

function parseAndDecode(json) {
  var match = S.parseJsonStringOrThrow(json, state);
  var match$1 = decodeMarkStates(json);
  var match$2 = decodeQuestionStates(json);
  return {
          questionStates: match$2,
          markStates: match$1,
          mode: match.mode,
          questionsComplete: match.questionsComplete,
          questionsCorrect: match.questionsCorrect,
          questionsIncorrect: match.questionsIncorrect,
          hasResponseMarking: match.hasResponseMarking
        };
}

function parseAndDecodeWithDefault(json) {
  try {
    return parseAndDecode(json);
  }
  catch (raw_exn){
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    if (exn.RE_EXN_ID === S.$$Error) {
      return {
              questionStates: /* [] */0,
              markStates: /* [] */0,
              mode: "Activity",
              questionsComplete: 0,
              questionsCorrect: 0,
              questionsIncorrect: 0,
              hasResponseMarking: true
            };
    }
    throw exn;
  }
}

function encodeQuestionStates(qs) {
  return Belt_List.toArray(Belt_List.map(qs, (function (q) {
                    var match = q[0];
                    if (typeof match !== "object") {
                      return {
                              questionIndex: q[1],
                              questionStateType: "NotAttempted"
                            };
                    } else {
                      return {
                              questionIndex: q[1],
                              questionStateType: "QuestionAttempted",
                              responseArray: S.reverseConvertToJsonOrThrow(match._0, responseArray),
                              questionMarking: match._1
                            };
                    }
                  })));
}

function encodeMarkStates(qs) {
  return Belt_List.toArray(Belt_List.map(qs, (function (q) {
                    var ansShpe = q[0];
                    if (typeof ansShpe !== "object") {
                      return {
                              questionIndex: q[1],
                              markStateType: "NotMarked"
                            };
                    } else {
                      return {
                              questionIndex: q[1],
                              markStateType: "BoolMarkState",
                              answerShape: S.reverseConvertToJsonOrThrow(ansShpe._0, answerShape)
                            };
                    }
                  })));
}

function encodeState(state) {
  return {
          questionStates: encodeQuestionStates(state.questionStates),
          markStates: encodeMarkStates(state.markStates),
          mode: state.mode,
          questionsComplete: state.questionsComplete,
          questionsCorrect: state.questionsCorrect,
          questionsIncorrect: state.questionsIncorrect,
          hasResponseMarking: state.hasResponseMarking
        };
}

function encode(s) {
  return JSON.stringify(encodeState(s));
}

export {
  responseIdentifier ,
  responsePayload ,
  responseType ,
  responseArray ,
  questionIndex ,
  questionMarkingSchema ,
  questionStateType ,
  answerShape ,
  markStateType ,
  state ,
  questionStates ,
  markStates ,
  questionStatesQuestionIndexes ,
  markStatesQuestionIndexes ,
  decodeQuestionStates ,
  decodeMarkStates ,
  parseAndDecode ,
  parseAndDecodeWithDefault ,
  encodeQuestionStates ,
  encodeMarkStates ,
  encodeState ,
  encode ,
}
/* responseIdentifier Not a pure module */
